import Label from '../../../ui/Label'
import Input from '../../../ui/Input'
import { CreateClientRequest } from '../../../../types/client';

interface ClientModalInputWrapProps {
    label: string;
    value: string;
    handleChange: (field: keyof CreateClientRequest, value: string) => void;
    typeOfAction: 'newClient' | 'update'
    type: string;
    placeholder?: string;
    field: keyof CreateClientRequest;
    isUpdateSchedule: boolean;
}

export default function ClientModalTimeInputWrap({ label, value, handleChange, typeOfAction, type, placeholder, field, isUpdateSchedule }: ClientModalInputWrapProps) {
    
    const isDisabled = typeOfAction === 'update' && !isUpdateSchedule;

    return (
        <div className='flex flex-col w-full'>
            <Label label={label}/>
            <div className='flex w-full space-x-2'>
                <div className='w-full'>
                    <Input
                        type={type}
                        value={value}
                        onChange={(e) => {
                            handleChange(field, e.target.value)
                        }}
                        placeholder={placeholder}
                        required
                        disabled={isDisabled}
                    />
                </div>
            </div>
        </div>
    )
}

